import { camelCase } from "lodash";
import { BlockManager } from "../BlockManager";
import { ElementType } from "@easy-email-pro-core/constants/blockType";
import { Element as NodeElement, TextNode } from "@easy-email-pro-core/typings";
import { NodeUtils } from "../NodeUtils";
import { HTML_BLOCK_NODE_TAGS } from "@easy-email-pro-core/constants";

const formateChildNotes = (node: Element): ChildNode[] => {
  const childNodes = Array.from(node.childNodes).filter(
    (item) => item.nodeType !== Node.COMMENT_NODE
  );

  const hasBlockElement = childNodes.some((item) => {
    return item.nodeType === Node.ELEMENT_NODE && isBlockNode({ item });
  });
  if (!hasBlockElement) {
    return childNodes;
  }

  function groupNodesByDisplay(node: Element) {
    const result = [];
    let currentGroup: { display: string; children: ChildNode[] } | null = null;
    const childNodes = Array.from(node.childNodes).filter(
      (item) => item.nodeType !== Node.COMMENT_NODE
    );

    for (const child of childNodes) {
      let display = "inline";

      if (
        child.nodeType === Node.ELEMENT_NODE &&
        isBlockNode({ item: child })
      ) {
        display = "block";
      }

      if (!currentGroup || currentGroup.display !== display) {
        currentGroup = { display: display, children: [] };
        result.push(currentGroup);
      }

      currentGroup!.children.push(child);
    }

    return result;
  }

  const deleteBrIndexs: number[] = [];

  const result = groupNodesByDisplay(node);
  const list: ChildNode[] = [];
  result.forEach((item) => {
    if (item.display === "inline") {
      const div = document.createElement("div");
      item.children.forEach((child) => {
        if (child.textContent?.trim()) {
          div.appendChild(child);
        }
      });
      if (div.childNodes.length > 0) {
        list.push(div);
      }
    } else {
      list.push(...item.children);
    }
  });

  list.forEach((node, index) => {
    if (node instanceof HTMLBRElement) {
      const previousSibling = list[index - 1];
      if (!(previousSibling instanceof HTMLBRElement)) {
        deleteBrIndexs.push(index);
      }
    }
  });

  deleteBrIndexs.reverse().forEach((dIndex) => {
    list.splice(dIndex, 1);
  });

  const div = document.createElement("div");
  div.replaceChildren(...list.map((item) => item.cloneNode(true)));
  return Array.from(div.childNodes);
};

const isBlockNode = ({ item }: { item: Element | ChildNode }) => {
  if (!(item instanceof Element)) return false;
  return HTML_BLOCK_NODE_TAGS.includes(item.tagName.toLowerCase());
};

export const HtmlNodeAdapter = (content: string) => {
  const div = document.createElement("div");
  div.innerHTML = content;

  return formateChildNotes(div).map((node) => {
    return getItemNode(node);
  });
};

const getItemNode = (node: ChildNode): TextNode | NodeElement => {
  if (node.nodeType === Node.TEXT_NODE) {
    let text = node.textContent || "";

    if (
      node.parentElement?.childNodes.length === 1 &&
      node.parentElement.textContent === node.textContent
    ) {
      text = node.parentElement.innerHTML.replace(/&nbsp;/gi, " ") || "";
    }
    text =
      text?.replace(/(?:(?!\u00A0|\xA0)\s)+/g, " ").replace(/\n/g, "") || "";

    if (node.previousSibling instanceof HTMLBRElement) {
      text = text.replace(/^ /, "");
    }
    if (
      node.parentElement?.childNodes.length === 1 &&
      (node.parentElement?.previousSibling instanceof HTMLBRElement ||
        node.parentElement?.previousSibling instanceof HTMLDivElement)
    ) {
      text = text.replace(/^ /, "");
    }

    return {
      text: text,
    };
  } else if (node.nodeType === Node.ELEMENT_NODE && node instanceof Element) {
    const attrs: Record<string, string> = {};

    node.getAttributeNames().forEach((name) => {
      let key = camelCase(name);
      if (key === "class") {
        key = "className";
      }
      attrs[key] = node.getAttribute(name) || "";
    });

    const tagName = node.tagName.toLowerCase();

    // if (tagName === "br") {
    //   return BlockManager.getBlockByType(ElementType.LINE_BREAK).create({
    //     attributes: {},
    //     data: {},
    //     children: [{ text: "" }],
    //   });
    // }

    // if (tagName === "br") {
    //   return BlockManager.getBlockByType(ElementType.HTML_BLOCK_NODE).create({
    //     attributes: attrs,
    //     data: {
    //       tagName: "div",
    //     },
    //     children: [{ text: "" }],
    //   });
    // }

    // 添加对 <img> 标签的处理
    if (tagName === "img") {
      return BlockManager.getBlockByType(ElementType.HTML_NODE).create({
        attributes: attrs,
        data: {
          tagName: "img",
        },
        children: [{ text: "" }],
      });
    } else if (tagName === "a") {
      if (node.children.length === 0 && node.childNodes.length === 1) {
        return {
          text: (node.textContent || "").trim(),
          link: {
            href: node.getAttribute("href") || "",
            blank: node.getAttribute("target") === "_blank",
          },
        };
      }
    }
    let formateChildren = formateChildNotes(node).map((child) =>
      getItemNode(child)
    );
    if (formateChildren.length === 0) {
      formateChildren.push({ text: "" });
    }
    const firstChild = formateChildren[0];
    if (
      tagName === "div" &&
      formateChildren.length === 1 &&
      NodeUtils.isTextNode(firstChild) &&
      firstChild.text === "&nbsp;"
    ) {
      formateChildren = [{ text: "" }];
    }
    if (HTML_BLOCK_NODE_TAGS.includes(tagName)) {
      return BlockManager.getBlockByType(ElementType.HTML_BLOCK_NODE).create({
        attributes: attrs,
        data: {
          tagName: tagName,
        },
        children: formateChildren,
      });
    }

    return BlockManager.getBlockByType(ElementType.HTML_NODE).create({
      attributes: attrs,
      data: {
        tagName: tagName,
      },
      children: formateChildren,
    });
  }
  console.log(`Invalid Node`, node);
  throw new Error("Invalid node");
};
